import type { ComponentProps } from 'react';

export const NnormalSVG = (props: ComponentProps<'svg'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="145" viewBox="0 0 496.18 84.98" {...props}>
    <g data-name="Layer 2">
      <g data-name="Calque 1">
        <path d="M209.74 82.78V24.89h45.34V41.1h-29.13v41.68h-16.21zM264.78 82.78V24.89h16.21v35.6l35.6-35.6h20.67v33.4l33.51-33.4h20.44v57.89H375V42.72l-40.06 40.06h-13.89V42.72l-40.06 40.06h-16.21zM424.41 66.57h25.24V41.33Zm-21.19 16.21V66.57l25.47-25.47h-26.28V24.89h63.45v57.89ZM479.97 1.74h16.21v81.05h-16.21zM0 42.24h18.26v40.57H0zM108.22 1.66h18.26v40.58h-18.26zM.05 12.904 12.96-.008l71.553 71.552-12.912 12.912zM42.02 12.904 54.93-.008l71.552 71.552-12.911 12.912zM168.23 69a15.17 15.17 0 1 1 14.94-15.17A15 15 0 0 1 168.23 69Zm0 16c17.6 0 31.26-13.43 31.26-31.14a31.26 31.26 0 0 0-62.52 0C137 71.55 150.75 85 168.23 85Z" />
      </g>
    </g>
  </svg>
);
